// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

type ProviderItemProps = {
  icon: string;
  title: string;
};

const ProviderItem = (props: ProviderItemProps) => {
  const { icon, title } = props;
  const t = useTranslate();

  return (
    <div className="ProviderItem">
      {!icon.includes("info") ? (
        <img className="ProviderItem__img" src={t(icon)} alt={title} />
      ) : (
        <span className="ProviderItem__number">+{t(icon)}</span>
      )}
      <span className="ProviderItem__title">{t(title)}</span>
    </div>
  );
};

export default ProviderItem;
